import React from "react";
//import Ads from "../../ad-config";
import { Bling as GPT } from "react-gpt";
  
GPT.enableSingleRequest();
export default class ROS_Middle_336_280 extends React.Component {
  render() {
    //console.log("props:",this.props.AdData);
    let Ads = this.props.AdData;
    return (
      <div className="ads_336_280">         <>       
      {(() => {
        if (Object.keys(this.props.AdData).length> 0 ) {
          return (
            <GPT
                  adUnitPath={Ads.adunitPath_rosMiddle300250}
                  
                  name={Ads.name_rosMiddle300250}
                   slotSize={[336, 280]}
      />
          )
        } 
      })()}
      </>
      </div>

    );
  }
}
